/**
 * Clean removes all the blank or empty nodes from an element
 * @param node
 * @param func
 * @returns {*}
 */
// node_walk: walk the element tree, stop when func(node) returns false
window.node_walk = function(node, func) {
  var result = func(node);
  for (node = node.firstChild; result !== false && node; node = node.nextSibling)
    result = node_walk(node, func);
  return result;
};

window.clean = function(node) {
  for (var n = 0; n < node.childNodes.length; n++) {
    var child = node.childNodes[n];
    if
    (
        child.nodeType === 8
        ||
        (child.nodeType === 3 && !/\S/.test(child.nodeValue))
    ) {
      node.removeChild(child);
      n--;
    } else if (child.nodeType === 1) {
      clean(child);
    }
  }
}

/**
 * Returns if event keypress is alphanumeric
 * @param e
 * @returns {boolean}
 */
window.isAlphaNumericKey = function(e) {
  var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
  var ret = ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || (keyCode == 32));
  return ret;
}

/**
 * Get object changes. Intersection is returned
 *
 * @param oldObj
 * @param newObj
 * @returns {{}|boolean}
 */
window.getObjChanges = function(oldObj, newObj) {
  if (JSON.stringify(oldObj) === JSON.stringify(newObj)) {
    return false;
  }
  var changes = {};
  newObj.forEach((item, index) => {
    if (!oldObj[index]) {
      changes = {[index]: newObj[index]};
    }
    if (newObj[index] !== oldObj[index]) {
      changes = {[index]: newObj[index]};
    }
  });
  return changes;
}

window.gotoPage = function(url) {
  window.location = url;
}

window.openInNewTab = function(url) {
  window.open(url, '_blank');
}

window.remove_non_ascii = function(str) {
  if ((str === null) || (str === ''))
    return false;
  else
    str = str.toString();

  return str.replace(/[^\x20-\x7E]/g, '');
}

window.resetAllInputs = function($el) {
  $el.querySelectorAll('input[type=radio]').forEach(element => element.checked=false);
  $el.querySelectorAll('input[type=text]').forEach(element => element.value='');
  $el.querySelectorAll('select').forEach(element => element.value='');

}
